import AppDataService from "./AppDataService";

export default class SignInDataService {
    
    static async checkIsAuthenticated(){
        return await AppDataService.get('User/IsAuthenticated', {
            headers: {
                'Content-Type': 'application/json'
            },
        });
    }
}